export class SvgAsset {
  private static readonly dir = '/asset/svg';

  public static readonly rocketLaunch = `${SvgAsset.dir}/rocket-launch.svg`;
  public static readonly shopify = `${SvgAsset.dir}/shopify.svg`;
}
